import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../../Common/ContentfulImage';
import SmartLink from '../../Common/SmartLink';
import * as ds from './DesktopStyles.module.css';

const OptionalNav = ({ optionalNav, imgLocation = 'Top' }) => {
  return (
    <>
      {optionalNav && (
        <div className={[imgLocation === 'Bottom' ? ds.optionalDivBottom : '', ds.optionalCard].join(' ')}>
          <SmartLink to={optionalNav.linkUrl}>
            {imgLocation === 'Bottom' && (
              <div className={ds.optionalLinkTop}>
                <SmartLink to={optionalNav.linkUrl}>{optionalNav.title}</SmartLink>
              </div>
            )}
            <ContentfulImage className={ds.optionalImage} objectFit={'contain'} imageFragment={optionalNav.image} />
            {imgLocation === 'Top' && (
              <div className={ds.optionalLinkBottom}>
                {optionalNav.title}
                {' ➔'}
              </div>
            )}
          </SmartLink>
        </div>
      )}
    </>
  );
};

OptionalNav.propTypes = {
  optionalNav: PropTypes.object,
  imgLocation: PropTypes.string,
};

OptionalNav.defaultProps = {
  optionalNav: null,
  imgLocation: 'Bottom',
};

export default OptionalNav;
